






























import { Vue, Component, Prop, p } from "av-ts";

import { IConsentForm, IOffering } from "../../interfaces/models";

@Component()
export default class ConsentForm extends Vue {

    @Prop consentForm = p<IConsentForm>({
        required: true
    });

    @Prop offering = p<IOffering>({
        required: true
    });

    @Prop response = p<boolean | undefined>({
        required: false
    });


    get currentResponse() {
        if (this.response === true) {
            return "Accepted";
        } else if (this.response === false) {
            return "Declined";
        }

        return "Unanswered";
    }

    hasResponded() {
        return this.response && this.response !== undefined;
    }

    alterConsent(newConsent: boolean) {
        this.$emit("change", newConsent);
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/profile/ConsentForm.vue